import { render, staticRenderFns } from "./viewCreditoTaller.vue?vue&type=template&id=00b42110"
import script from "./viewCreditoTaller.vue?vue&type=script&lang=js"
export * from "./viewCreditoTaller.vue?vue&type=script&lang=js"
import style0 from "./viewCreditoTaller.vue?vue&type=style&index=0&id=00b42110&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports